import React from 'react';
import * as MyCells from '../../../../../utils/Cells';
import ActionMenu from '../../../../common/action/ActionMenu';
import DateRangeColumnFilter, { DateRangeColumnFilterFn } from '../../../../common/filters/DateRangeColumnFilter';
import { MultiSelectFilterFn } from '../../../../common/filters/Filters';
import MultiSelectColumnFilter from '../../../../common/filters/MultiSelectColumnFilter';
import TextColumnFilter from '../../../../common/filters/TextColumnFilter';

export const columns = (refresh) => {
    return [
        {
            Header: 'Év',
            accessor: 'year',
            id: 'year',
            show: true,
            className: 'idColumn center',
            Filter: MultiSelectColumnFilter,
            filter: MultiSelectFilterFn,
        },
        {
            Header: 'Mikortól',
            accessor: 'availableFrom',
            id: 'availableFrom',
            show: true,
            className: 'dateColumn',
            Filter: DateRangeColumnFilter,
            filter: DateRangeColumnFilterFn,
            Cell: props => <MyCells.DateCell value={props.value} />,
        },
        {
            Header: 'Meddig',
            accessor: 'availableUntil',
            id: 'availableUntil',
            show: true,
            className: 'dateColumn',
            Filter: DateRangeColumnFilter,
            filter: DateRangeColumnFilterFn,
            Cell: props => <MyCells.DateCell value={props.value} />,
        },
        {
            Header: 'Összeg',
            accessor: 'amount',
            id: 'amount',
            show: true,
            className: 'right amountColumn',
            Filter: TextColumnFilter,
            Cell: props => <MyCells.NumberCell value={props.value} />,
        },
        {
            Header: 'Hátravan',
            accessor: 'remainingAmount',
            id: 'remainingAmount',
            show: true,
            className: 'right amountColumn',
            Filter: TextColumnFilter,
            Cell: props => <MyCells.NumberCell value={props.value} />,
        },
        {
            id: 'menu',
            show: true,
            headerClassName: 'actions',
            className: 'actions',
            Header: () => null, // No header
            Cell: value => <ActionMenu row={value.row.original} tabletype={'availabledividend'} refresh={refresh} />,
        },

    ]
}